// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Register from './components/Registeration';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Navbar from './components/navbar/Navbar';
import Login from './components/Login/Login';
import './Styles/style.css'
import './Styles/adminstyle.css'
import './Styles/staffstyle.css'
import './Styles/core.css'
import Layout from './components/Layout';
import Proceedings from './pages/Proceedings/Proceedings';
import Members from './pages/Proceedings/Members';
import ProtectedRoute from './security/ProtectedRoute';
import AdminLayout from './components/AdminComponents/layout/AdminLayout';
import AdminDashboard from './pages/Admin/AdminDashboard';
import AdminEmployeesPage from './pages/Admin/AdminEmployeesPage';
import AdminLocationPage from './pages/Admin/AdminLocationPage';
import AdminDepartmentPage from './pages/Admin/AdminDepartmentPage';
import AdminDesignationPage from './pages/Admin/AdminDesignationPage';
import AdminWardsPage from './pages/Admin/AdminWardsPage';
import AdminCommitteePage from './pages/Admin/AdminCommitteePage';
import AdminWorkTypePage from './pages/Admin/AdminWorkTypePage';
import AdminTenderTypePage from './pages/Admin/AdminTenderTypePage';
import AdminAlertTypePage from './pages/Admin/AdminAlertTypePage';
import UnauthorizedPage from './components/UnauthorizedPage';
import Employees from './pages/Proceedings/Employees';
import Committee from './pages/Proceedings/Committee';
import Meetings from './pages/Proceedings/Meetings';
import Agendas from './pages/Proceedings/Agendas';
import Resolutions from './pages/Proceedings/Resolutions';
import PlanEstimates from './pages/Proceedings/PlanEstimates';
import TechnicalSanctionsWorkTypesPage from './pages/Proceedings/TechnicalSanctionsPages/TechnicalSanctionsWorkTypesPage';
import TechnicalSanctionEstimatesList from './pages/Proceedings/TechnicalSanctionsPages/TechnicalSanctionEstimatesList';
import AdminSanctionsWorkTypesPage from './pages/Proceedings/AdminSanctionsPages/AdminSanctionsWorkTypesPage';
import AdminSanctionEstimatesList from './pages/Proceedings/AdminSanctionsPages/AdminSanctionEstimatesList';
import TenderProcess from './pages/Proceedings/TenderProcess';
import NegotiationProcess from './pages/Proceedings/NegotiationProcess';
import AggreementProcess from './pages/Proceedings/AggreementProcess';
import WorkOrderProcess from './pages/Proceedings/WorkOrderProcess';
import ApprovePlanEstimate from './pages/Approvals/ApprovePlanEstimate';
import Approvals from './pages/Approvals/Approvals';
import TheoreticalSanctionApproval from './pages/Approvals/TheoreticalSanction/TheoreticalSanctionApproval';
import ApproveAdminSanction from './pages/Approvals/AdminSanction/ApproveAdminSanction';
import ApproveTechnicalSanction from './pages/Approvals/TechnicalSanction/ApproveTechnicalSanction';
import ApproveTenderProcess from './pages/Approvals/TenderProcess/ApproveTenderProcess';
import ApproveNegotiation from './pages/Approvals/NegotiationProcess/ApproveNegotiation';
import ApproveAgreement from './pages/Approvals/AgreementProcess/ApproveAgreement';
import ApproveWorkOrder from './pages/Approvals/WorkOrder/ApproveWorkOrder';
import Attendance from './pages/Attendance/Attendance';
import MarkAttendance from './pages/Attendance/MarkAttendance/MarkAttendance';
import DailyAttendance from './pages/Attendance/DailyAttendance/DailyAttendance';
import AttendanceSummary from './pages/Attendance/AttendanceSummary/AttendanceSummary';
import Complaints from './pages/Complaints/Complaints';
import Rti from './pages/RTI/Rti';
import WorkDashboard from './pages/Work/WorkDasboard';
import ApprovedWorkOrders from './pages/Work/ApprovedWorkOrders';
import AddWorkForm from './pages/Work/AddWorkForm';
import WorksCompletedDashboard from './pages/WorkCompleted/WorksCompletedDashboard';
import WorkCompletionList from './pages/WorkCompleted/WorkCompletionList';
import WorkCompletionForm from './pages/WorkCompleted/WorkCompletionForm';
import AccountMenusPage from './pages/Accounts/AccountMenusPage';
import BudgetHeadPage from './pages/Accounts/BudgetHeadPage';
import PaymentWorkTypePage from './pages/Accounts/PaymentWorkTypePage';
import PaymentWorkOrderList from './pages/Accounts/PaymentWorkOrderList';
import AddWorkOrderForm from './components/dashboard/Prceedings/WorkOrder/AddWorkOrderForm';
import WorkPaymentForm from './pages/Accounts/WorkPaymentForm';
import SitePicturesWorkTypePage from './pages/SitePictures/SitePicturesWorkTypePage';
import SitePicturesWorkOrderList from './pages/SitePictures/SitePicturesWorkOrderList';
import SitePicturesForm from './pages/SitePictures/SitePicturesForm';
import VoiceWorkTypePage from './pages/Voice/VoiceWorkTypePage';
import VoiceWorkOrderList from './pages/Voice/VoiceWorkOrderList';
import VoiceForm from './pages/Voice/VoiceForm';
import DroneVideosWorkTypePage from './pages/DroneVideos/DroneVideosWorkTypePage';
import DroneVideosWorkOrderList from './pages/DroneVideos/DroneVideosWorkOrderList';
import VideoForm from './pages/DroneVideos/VideoForm';
import StaffAlertTypePage from './pages/StaffAlert/StaffAlertTypePage';
import StaffAlertDetailsPage from './pages/StaffAlert/StaffAlertDetailsPage';
import AlertOverBudgetPage from './pages/StaffAlert/StaffAlertDetailsPage';
import OverBudgetPaymentDetailsPage from './pages/StaffAlert/OverBudgetPaymentDetailsPage';
import NewsPage from './pages/News/NewsPage';
import ViewNews from './pages/News/ViewNews';
import RtiAlertDetailsPage from './pages/StaffAlert/Rti/RtiAlertDetailsPage';
import CompletionAlertDetailsPage from './pages/StaffAlert/IssuedCompletion/CompletionAlertDetailsPage';
import OutOfTimelineDetailsPage from './pages/StaffAlert/OutOfTimeline/OutOfTimelineDetailsPage';
import AboutUs from './pages/AboutUs';

const App = () => {
  return (
    <>
      <Router>
        <Routes>

          {/* ---------- PUBLIC ---------- */}
          <Route path="/" element={<Navigate to="/smartcity/login" replace />} />
          <Route path="/smartcity" element={<Navigate to="/smartcity/login" replace />} />

          <Route path="/smartcity/login" element={<Login />} />
          <Route path="/smartcity/forgot-password" element={<ForgotPassword />} />
          <Route path="/smartcity/reset-password" element={<ResetPassword />} />
          <Route path="/smartcity/unauthorizedpage" element={<UnauthorizedPage />} />


          {/* ---------- ADMIN ---------- */}
          <Route element={<ProtectedRoute roles={["ADMIN"]} />}>
            <Route element={<AdminLayout />}>
              <Route path="/smartcity/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/smartcity/admin/employees" element={<AdminEmployeesPage />} />
              <Route path="/smartcity/admin/location" element={<AdminLocationPage />} />
              <Route path="/smartcity/admin/departments" element={<AdminDepartmentPage />} />
              <Route path="/smartcity/admin/designations" element={<AdminDesignationPage />} />
              <Route path="/smartcity/admin/wards" element={<AdminWardsPage />} />
              <Route path="/smartcity/admin/committees" element={<AdminCommitteePage />} />
              <Route path="/smartcity/admin/work-types" element={<AdminWorkTypePage />} />
              <Route path="/smartcity/admin/tender-types" element={<AdminTenderTypePage />} />
              <Route path="/smartcity/admin/alert-types" element={<AdminAlertTypePage />} />
            </Route>
          </Route>

          {/* ---------- USER ---------- */}
          <Route element={<ProtectedRoute roles={["USER"]} />}>

            <Route element={<Layout />}>
              <Route path="/smartcity/dashboard" element={<Dashboard />} />

              {/* Routings from dashboard  */}
              <Route path="/smartcity/proceedings" element={<Proceedings />} />

              {/* Routings from Proceedings */}
              <Route path="/smartcity/proceedings/members" element={<Members />} />

              <Route path="/smartcity/proceedings/employees" element={<Employees />} />

              <Route path="/smartcity/proceedings/committee" element={<Committee />} />

              <Route path="/smartcity/proceedings/meetings" element={<Meetings />} />

              <Route path="/smartcity/proceedings/agendas" element={<Agendas />} />

              <Route path="/smartcity/proceedings/resolutions" element={<Resolutions />} />

              <Route path="/smartcity/proceedings/plan-estimates" element={<PlanEstimates />} />

              <Route
                path="/smartcity/proceedings/admin-sanctions"
                element={<AdminSanctionsWorkTypesPage />}
              />
              <Route
                path="/smartcity/proceedings/admin-sanctions/plan-estimates/:workTypeId"
                element={<AdminSanctionEstimatesList />}
              />

              {/* Technical Sanctions */}
              <Route path="/smartcity/proceedings/technical-sanctions" element={<TechnicalSanctionsWorkTypesPage />} />
              <Route path="/smartcity/proceedings/technical-sanctions/plan-estimates/:workTypeId" element={<TechnicalSanctionEstimatesList />} />

              <Route path="/smartcity/proceedings/tender-process" element={<TenderProcess />} />


              <Route path="/smartcity/proceedings/negotiation-process" element={<NegotiationProcess />} />

              <Route path="/smartcity/proceedings/aggreement-process" element={<AggreementProcess />} />

              <Route path="/smartcity/proceedings/work-order" element={<WorkOrderProcess />} />

              {/* Proceedings Section Ends */}

              {/* Approvals Section Starts */}

              <Route path="/smartcity/approvals" element={<Approvals />} />

              <Route path="/smartcity/approvals/plan-estimates" element={<ApprovePlanEstimate />} />

              <Route path="/smartcity/approvals/theoretical-sanctions" element={<TheoreticalSanctionApproval />} />
              <Route path="/smartcity/approvals/admin-sanctions" element={<ApproveAdminSanction />} />
              <Route path="/smartcity/approvals/technical-sanctions" element={<ApproveTechnicalSanction />} />
              <Route path="/smartcity/approvals/tender-process" element={<ApproveTenderProcess />} />
              <Route path="/smartcity/approvals/negotiation-process" element={<ApproveNegotiation />} />
              <Route path="/smartcity/approvals/agreement-process" element={<ApproveAgreement />} />
              <Route path="/smartcity/approvals/work-order" element={<ApproveWorkOrder />} />

              {/* Attendance Section */}
              <Route path="/smartcity/attendance" element={<Attendance />} />

              <Route element={<ProtectedRoute designations={["Junior Clerk", "Senior Clerk"]} />}>
                <Route path="/smartcity/attendance/mark-attendance" element={<MarkAttendance />} />
              </Route>

              <Route path="/smartcity/attendance/daily-attendance" element={<DailyAttendance />} />
              <Route path="/smartcity/attendance/attendance-summary" element={<AttendanceSummary />} />

              {/* Complaints Section */}

              <Route path="/smartcity/complaints" element={<Complaints />} />

              {/* RTI Section */}

              <Route path="/smartcity/rti" element={<Rti />} />

              {/* Work Section */}

              <Route path="/smartcity/works" element={<WorkDashboard />} />
              <Route path="/smartcity/works/approved-work-orders/:workTypeId" element={<ApprovedWorkOrders />} />
              <Route path="/smartcity/works/approved-work-orders/add-work/:workOrderId" element={<AddWorkForm />} />

              {/* Works Completed */}

              <Route path="/smartcity/works-completion" element={<WorksCompletedDashboard />} />
              <Route path="/smartcity/works-completion/works-for-completion/:workTypeId" element={<WorkCompletionList />} />
              <Route path="/smartcity/works-completion/works-for-completion/add-completion/:workOrderId" element={<WorkCompletionForm />} />

              {/* Accounts */}
              <Route path="/smartcity/accounts" element={<AccountMenusPage />} />
              <Route path="/smartcity/accounts/budget-head" element={<BudgetHeadPage />} />

              <Route path="/smartcity/accounts/payment" element={<PaymentWorkTypePage />} />
              <Route path="/smartcity/accounts/payment/:workTypeId" element={<PaymentWorkOrderList />} />

              <Route path="/smartcity/accounts/payment/add-payment/:workOrderId" element={<WorkPaymentForm />} />

              {/* Site Pictures */}

              <Route path="/smartcity/visit-sites" element={<SitePicturesWorkTypePage />} />
              <Route path="/smartcity/visit-sites/work-orders-sites/:workTypeId" element={<SitePicturesWorkOrderList />} />
              <Route path="/smartcity/visit-sites/work-orders-sites/add-site-pictures/:workOrderId" element={<SitePicturesForm />} />

              {/* Voice */}

              <Route path="/smartcity/voice" element={<VoiceWorkTypePage />} />
              <Route path="/smartcity/voice/work-orders-voice/:workTypeId" element={<VoiceWorkOrderList />} />
              <Route path="/smartcity/voice/work-orders-voice/add-voice/:workOrderId" element={<VoiceForm />} />

              {/* Drone Videos */}

              <Route path="/smartcity/video" element={<DroneVideosWorkTypePage />} />
              <Route path="/smartcity/video/work-orders-video/:workTypeId" element={<DroneVideosWorkOrderList />} />
              <Route path="/smartcity/video/work-orders-video/add-video/:workOrderId" element={<VideoForm />} />

              {/* Alert Section */}

              <Route path="/smartcity/staff-alerts" element={<StaffAlertTypePage />} />
              <Route path="/smartcity/staff-alerts/over-budget" element={<AlertOverBudgetPage />} />
              <Route path="/smartcity/staff-alerts/over-budget/payment-details" element={<OverBudgetPaymentDetailsPage />} />
              <Route path="/smartcity/staff-alerts/rti-details" element={<RtiAlertDetailsPage />} />
              <Route path="/smartcity/staff-alerts/issued-completion" element={<CompletionAlertDetailsPage />} />
              <Route path="/smartcity/staff-alerts/out-of-timeline" element={<OutOfTimelineDetailsPage />} />

              {/* News Section */}
              <Route path="/smartcity/news" element={<NewsPage />} />
              <Route path="/smartcity/news/details" element={<ViewNews />} />

              {/* About Us */}
              <Route path="/smartcity/about-us" element={<AboutUs />} />


            </Route>
          </Route>

          {/* ---------- FALLBACK ---------- */}
          <Route path="*" element={<Navigate to="/smartcity/unauthorizedpage" replace />} />

        </Routes>
      </Router >
    </>
  );
};

export default App;
